const updateWindowTitle = (title) => {
    const SEPARATOR = ' - ';
    const titleParts = document.title.split(SEPARATOR);
    titleParts[0] = title;
    document.title = titleParts.join(SEPARATOR);
};

const updateWindowDraftTitle = (title) => updateWindowTitle(`Editing ${title}`);

export {
    updateWindowTitle,
    updateWindowDraftTitle,
};
